import { IntegrityMonitorAssignRulesFormController } from '../controller/IntegrityMonitorAssignRulesFormController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { IntegrityMonitorRuleGridItem } from '../../integrityMonitorRulesGrid/types';
import { RuleSetOption } from '../types';

export class IntegrityMonitorAssignRulesFormWebComponent extends BaseWebComponentElement {
  private ruleIdsRef?: Array<string>;
  private selectedRuleSetIdsRef?: Array<string>;
  private ruleSetOptionsRef?: Array<RuleSetOption>;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorAssignRulesFormController,
    });
  }

  get isVisible(): boolean | undefined {
    if (this.hasAttribute('data-is-visible')) {
      const value = this.getAttribute('data-is-visible');
      return value ? JSON.parse(value) : undefined;
    }

    return undefined;
  }

  set isVisible(value: boolean | undefined) {
    if (value) {
      this.setAttribute('data-is-visible', '');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }

  get ruleIds(): Array<string> | undefined {
    return this.ruleIdsRef;
  }

  set ruleIds(value: Array<string> | undefined) {
    this.ruleIdsRef = value;
  }

  get selectedRuleSetIds(): Array<string> | undefined {
    return this.selectedRuleSetIdsRef;
  }

  set selectedRuleSetIds(value: Array<string> | undefined) {
    this.selectedRuleSetIdsRef = value;
  }

  get ruleSetOptions(): Array<RuleSetOption> | undefined {
    return this.ruleSetOptionsRef;
  }

  set ruleSetOptions(value: Array<RuleSetOption> | undefined) {
    this.ruleSetOptionsRef = value;
  }
}
